export const ADMIN_REPORT_DETAILS = 'ADMIN_REPORT_DETAILS';
export const ADMIN_HOTEL_REPORT_DETAILS = 'ADMIN_HOTEL_REPORT_DETAILS';
export const ADMIN_TOUR_REPORT_DETAILS = 'ADMIN_TOUR_REPORT_DETAILS';
export const ADMIN_BUS_REPORT_DETAILS = 'ADMIN_BUS_REPORT_DETAILS';
export const CLEAR_ADMIN_REPORT = 'CLEAR_ADMIN_REPORT';
export const ADMIN_REPORTS = 'ADMIN_REPORTS';
export const ADMIN_REPORTS_ORIGINAL = 'ADMIN_REPORTS_ORIGINAL';
export const FETCH_ALL_AGENTS = 'FETCH_ALL_AGENTS';
export const NOTE_ADD = 'NOTE_ADD';
export const NOTES = 'NOTES';
export const EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION';
export const GET_PROVIDERS = 'GET_PROVIDERS';
export const TRIGGER_REQUEST = 'TRIGGER_REQUEST';
export const END_REQUEST = 'END_REQUEST';
export const ORDER_PENALTIES = 'ORDER_PENALTIES';
export const ORDER_CANCELLATION_PENALTIES_V5 = 'ORDER_CANCELLATION_PENALTIES_V5';
export const ADMIN_BUS_CANCELLATION_PENALTIES = 'ADMIN_BUS_CANCELLATION_PENALTIES';
export const GET_REISSUANCE_DETAILS = 'GET_REISSUANCE_DETAILS';
export const AIRLINE_VOUCHERS = 'AIRLINE_VOUCHERS';
export const LOSS_REPORTS = 'LOSS_REPORTS';
export const LOSS_REPORTED = 'LOSS_REPORTED';
export const LOSS_REPORT_UPDATED = 'LOSS_REPORT_UPDATED';
export const ORDER_LOSS_REPORTS = 'ORDER_LOSS_REPORTS';
export const LOSS_CAPABILITIES = 'LOSS_CAPABILITIES';
export const AIRLINE_VOUCHER_DETAIL = 'AIRLINE_VOUCHER_DETAIL';
export const AIRLINE_VOUCHER_AIRLINES = 'AIRLINE_VOUCHER_AIRLINES';
export const CLEAR_AIRLINE_VOUCHER_DETAIL = 'CLEAR_AIRLINE_VOUCHER_DETAIL';
export const REFUND_REQUESTS = 'REFUND_REQUESTS';
